import React from 'react';
import {motion} from 'framer-motion';
import './pageMessagePaymentControl.css'


const PageMessagePaymentControl =({textMessage})=>{



    return (
            <motion.div initial={{opaxity:0, y:300}} animate={{opacity:1, y:0}} id="alert-paymeny-control" className="fixed top-20 right-0 rounded-2xl  mx-3 border-2 border-red-600 bg-red-500 bg-opacity-80 w-auto sm:w-3/5 md:w-1/3 lg:w-1/3 h-auto">
                <div className="p-2 text-gray-900 font-bold flex flex-rows-1">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 ms:h-14 sm:w-14  text-red-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01" />
                        </svg>
                    </div>
                    <div className="my-auto w-2/1 text-base  tetx-justify">
                     {textMessage?textMessage:''}
                    </div>
                </div>
            </motion.div>
    )
}


export default PageMessagePaymentControl;